<div class="palm-product">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#palm-prod'"></app-title-page>
            </div>
            <!-- contents -->
            <div class="col-md-12 sec-contents" id="palm-prod">
                <div class="lane-top pt-5">
                    <div class="desc text-justify" [innerHTML]="dataSection[0]?.content"></div>
                    <div class="thumbnail my-4 py-3">
                        <div class="row">
                            <div class="col-md-11 mx-auto">
                                <div class="row px-md-0 px-2">
                                    <div class="col-6 px-md-3 px-1">
                                        <div class="px-xl-4 px-md-3">
                                            <img [src]="apiAsset + dataSection[0]?.picture" class="w-100" alt="">
                                        </div>
                                    </div>
                                    <div class="col-6 px-md-3 px-1">
                                        <div class="px-xl-4 px-md-3">
                                            <img [src]="apiAsset + dataSection[1]?.picture" class="w-100" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                     <div class="desc text-justify" [innerHTML]="dataSection[1]?.content"></div>
                </div>
            </div>
        </div>
    </div>    
</div>

